import {Component, EventEmitter, HostBinding, Input, Output} from "@angular/core";
import {IconButtonType} from "./icon-button";

@Component({
    selector: "woa-icon-button",
    templateUrl: "./icon-button.component.html",
})
export class IconButtonComponent {
    @Input() @HostBinding("attr.type") type: IconButtonType;
    @Input() icon: string;
    @Input() @HostBinding("class.disabled") disabled: boolean = false;
    @Input() @HostBinding("class.unavailable") unavailable: boolean = false;
    @Input() circular: boolean = false;
    @Input() enlarged: boolean = false;

    @Output() onActivate: EventEmitter<void> = new EventEmitter();

    get iconName(): string {
        if (this.icon) {
            return this.icon;
        }
        switch (this.type) {
            case IconButtonType.BACK:
                return "arrow-left";
            case IconButtonType.FORWARD:
                return "arrow-right";
            case IconButtonType.LEFT:
                return "angle-left";
            case IconButtonType.RIGHT:
                return "angle-right";
            case IconButtonType.CLOSE:
                return "cross";
            case IconButtonType.TOP:
                return "angle-double-small-up";
            case IconButtonType.EXIT:
                return "exit";
            case IconButtonType.REFRESH:
                return "rotate-right";
            case IconButtonType.MENU:
                return "menu-burger";
            case IconButtonType.SETTINGS:
                return "settings";
            case IconButtonType.INCREMENT:
                return "plus";
            case IconButtonType.DECREMENT:
                return "minus";
            case IconButtonType.REMOVE:
                return "trash";
            case IconButtonType.SHOW:
                return "eye";
            case IconButtonType.HIDE:
                return "eye-crossed";
            case IconButtonType.SCAN:
                return "qrcode";
            case IconButtonType.SEARCH:
                return "search";
            default:
                return undefined;
        }
    }

    get defaultIconSize(): number {
        switch (this.type) {
            case IconButtonType.CLOSE:
                return 21;
            case IconButtonType.REFRESH:
                return 21;
            case IconButtonType.INCREMENT:
                return 12;
            case IconButtonType.DECREMENT:
                return 12;
            case IconButtonType.REMOVE:
                return 18;
            case IconButtonType.SEARCH:
                return 21;
            default:
                return 25;
        }
    }

    activate(event: MouseEvent): void {
        event.stopPropagation();
        this.onActivate.emit();
    }
}



// WEBPACK FOOTER //
// ./src/app/buttons/icon-button/icon-button.component.ts